import { handleActions } from 'redux-actions';
import { createSimpleHandler } from 'store/utils/createSimpleHandler';
import { createClearHandler } from 'store/utils/createClearHandler';
import { setSnackbarMessage, clearSnackbarMessage } from 'store/global/actions';

export interface IGlobalStoreState {
  snackbarMessage?: string;
}

const defaultState: IGlobalStoreState = {
  snackbarMessage: undefined,
};

const reducer = handleActions(
  {
    [setSnackbarMessage.type]: createSimpleHandler('snackbarMessage'),
    [clearSnackbarMessage.type]: createClearHandler('snackbarMessage'),
  },
  defaultState
);

export default reducer;
